module.exports = __webpack_public_path__ + "static/img/city09.1a1c165.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/city09.jpg
// module id = iXpV
// module chunks = 0